const data = [
  {
    home_page: {
      title:
        "Home - Aalan TechSoft | Software Development & Software Training in Salem",
      meta: {
        meta1: {
          name: "description",
          content:
            "Whether you're a beginner or upskilling, our practical training helps you apply knowledge, build real projects, and create a strong portfolio.",
        },
      },
    },

    about_page: {
      title:
        "About Us - Aalan TechSoft | Software Development & Software Training in Salem",
      meta: {
        meta1: {
          name: "description",
          content:
            "At Aalan TechSoft, our mission is to empower learners and businesses with innovative training and custom-built software solutions.",
        },
      },
    },

    courses_page: {
      title:
        "Courses - Aalan TechSoft | Software Development & Software Training in Salem",
      meta: {
        meta1: {
          name: "description",
          content:
            "Explore our industry-focused courses in Full Stack Development, Web Design, App Development, and Software Training – designed to help you succeed.",
        },
      },
    },

    services_page: {
      title:
        "Services - Aalan TechSoft | Software Development & Software Training in Salem",
      meta: {
        meta1: {
          name: "description",
          content:
            "Discover our end-to-end services including software development, website design, app creation, digital marketing, and enterprise IT solutions.",
        },
      },
    },

    portfolio_page: {
      title:
        "Portfolio - Aalan TechSoft | Our Projects in Software & Training",
      meta: {
        meta1: {
          name: "description",
          content:
            "Take a look at Aalan TechSoft’s portfolio showcasing our software development projects, training success stories, and client collaborations.",
        },
      },
    },

    blogs_page: {
      title:
        "Blogs - Aalan TechSoft | Software Development & Training Insights",
      meta: {
        meta1: {
          name: "description",
          content:
            "Stay updated with the latest insights, tips, and trends in software development, training, and technology with Aalan TechSoft’s blogs.",
        },
      },
    },

    blogssub_page: {
      title:
        "Blog Details - Aalan TechSoft | Software Development & Training Insights",
      meta: {
        meta1: {
          name: "description",
          content:
            "Read in-depth articles and guides on technology, coding, and career development from Aalan TechSoft experts.",
        },
      },
    },

    testimonial_page: {
      title:
        "Testimonials - Aalan TechSoft | Hear From Our Students & Clients",
      meta: {
        meta1: {
          name: "description",
          content:
            "Discover success stories from students and clients who trusted Aalan TechSoft for software training and custom IT solutions.",
        },
      },
    },

    contactus_page: {
      title:
        "Contact Us - Aalan TechSoft | Software Development & Training in Salem",
      content:
        "Ready to start your journey with Aalan TechSoft? Get in touch with us today to learn more about our services and training programs.",
      meta: {
        meta1: {
          name: "description",
          content:
            "Reach out to Aalan TechSoft, Salem’s trusted software development company and training institute for all your tech needs.",
        },
      },
    },

    cookieContent:
      "We use cookies to improve your browsing experience, personalize content, and analyze our traffic. By using our site, you agree to our cookie policy.",
  },
];

export default data;
